import { useEffect, useMemo, useState } from "react";
import AssetCard from "../components/UI/AssetCard";
import { ASSET_TYPES, fetchAssetsByType } from "../api/assetApi";

export default function TrainingClasses() {
  const [classes, setClasses] = useState([]);
  const [activeCategory, setActiveCategory] = useState("all");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchAssetsByType(ASSET_TYPES.CLASSES)
      .then(setClasses)
      .catch((err) => setError(err.message || "Failed to load classes"))
      .finally(() => setLoading(false));
  }, []);

  const categories = useMemo(
    () => [...new Set(classes.map((item) => item.category).filter(Boolean))],
    [classes]
  );
  const visible =
    activeCategory === "all"
      ? classes
      : classes.filter((item) => item.category === activeCategory);

  return (
    <section className="space-top">
      <div className="container">
        <div className="about-title mb-4">
          <h1 className="text-lora font-semibold">Training Classes</h1>
          <p>
            Explore classes and courses from Asset Master with asset type
            Classes/Courses.
          </p>
        </div>

        {categories.length > 1 && (
          <div className="d-flex flex-wrap gap-2 mb-4">
            <button
              className={`btn cutom-tab-style ${
                activeCategory === "all" ? "active-tab-btn-style" : ""
              }`}
              onClick={() => setActiveCategory("all")}
            >
              All
            </button>
            {categories.map((category) => (
              <button
                key={category}
                className={`btn cutom-tab-style ${
                  activeCategory === category ? "active-tab-btn-style" : ""
                }`}
                onClick={() => setActiveCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>
        )}

        {loading && <p className="text-center py-5">Loading classes...</p>}
        {error && <p className="text-center text-danger py-5">{error}</p>}
        {!loading && !error && visible.length === 0 && (
          <p className="text-center py-5">No classes available.</p>
        )}
        <div className="row g-4">
          {visible.map((item) => (
            <div key={item.id} className="col-lg-4 col-md-6 col-12 d-flex">
              <AssetCard
                asset={item}
                actionLabel="Enroll Now"
                actionTo="/enroll"
                className="training-class-card"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
